import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgZorroAntdModule, NzButtonModule, NzDatePickerModule, NzDividerModule, NzDropDownModule, NzGridModule, NzIconModule, NzInputModule, NzPaginationModule, NzSelectModule, NzTableModule, NzTagModule, NzToolTipModule } from '../utilities/ng-zorro-antd.module';
import { SettlementsComponent } from './settlements.component';
import { MomentModule } from 'ngx-moment';
import { SettlementRoutingModule } from './settlements.routing.module';
import { DoSettlementComponent } from './do-settlement/do-settlement.component';
import { DownloadService } from '../reports/download-service';
import { ViewDetailsModule } from '../view-details/view-details.module';
import { SettlementDocumentsComponent } from './settlement-documents/settlement-documents.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgZorroAntdModule,
        SettlementRoutingModule,
        MomentModule,
        ViewDetailsModule,
        NzSelectModule,
        NzDropDownModule,
        NzTableModule,
        NzTagModule,
        NzButtonModule,
        NzGridModule,
        NzToolTipModule,
        NzPaginationModule,
        NzDatePickerModule,
        NzInputModule,
        NzIconModule,
        NzDividerModule
    ],
    declarations: [SettlementsComponent, DoSettlementComponent, SettlementDocumentsComponent],
    exports: [DoSettlementComponent, SettlementDocumentsComponent],
    providers: [DownloadService]
})

  export class SettlementModule {

  }
